import { intersection } from "lib/actions/util";
import { isSetSubsetOfArray } from "lib/actions/util/isSetSubsetOfArray";
import { getFileExtensions } from "./utils";

export const cesium3dTileExtensions = {
  // At the moment I have included b3dm as required, but in the future it is possible to have
  // a i3dm or pnts file instead of a b3dm file.
  required: new Set(["b3dm", "json"]),
  optional: new Set(),
};

const cesium3dTileExtensionsAll = [
  ...cesium3dTileExtensions.required,
  ...cesium3dTileExtensions.optional,
];

export const is3dTile = (filenames: string[]) => {
  const exts = getFileExtensions(filenames);
  return intersection(exts, cesium3dTileExtensionsAll).length > 0;
};

export const isComplete3dTile = (filenames: string[]) =>
  isSetSubsetOfArray(
    cesium3dTileExtensions.required,
    getFileExtensions(filenames),
  );

export const isUnsupported3dTile = (filenames: string[]) => {
  const exts = getFileExtensions(filenames);
  return intersection(exts, cesium3dTileExtensionsAll).length !== exts.length;
};
